module.exports = __webpack_public_path__ + "static/media/Background_Golden_Gate_Bridge.f055f032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Background_Golden_Gate_Bridge.jpg
// module id = 68
// module chunks = 0